import cn from 'classnames'
import { FunctionComponentType } from '@interfaces/commons/FunctionComponent'

export function StoryCoverSkeleton({ className }: FunctionComponentType) {
  return (
    <section
      className={cn(
        'card p-[30px] mobile:p-0 animate-pulse dark:border-purple',
        className
      )}
    >
      <div className='desktop-tablet:flex w-full space-x-[30px] mobile:sapce-x-0'>
        <div className='w-[372px] mobile:w-full h-[533px] bg-gray dark:bg-dark-9 rounded-[8px]' />
        <div className='desktop:flex-1 mobile:p-5'>
          <div className='w-[80%] h-[16px] bg-gray dark:bg-dark-9' />
          <div className='flex items-center mt-[20px]'>
            <div className='bg-gray dark:bg-dark-9 w-[40px] h-[40px] rounded-full' />
            <div className='w-[100px] h-[12px] bg-gray dark:bg-dark-9 ml-[10px]' />
          </div>
          <div className='w-full h-[12px] bg-gray dark:bg-dark-9 mt-[20px]' />
          <div className='w-[60%] h-[12px] bg-gray dark:bg-dark-9 mt-[10px]' />
          <div className='grid grid-cols-3 mobile:grid-cols-2 gap-x-[50px] gap-y-[20px] mt-[80px] mobile:mt-[20px]'>
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={`info-${i}`}>
                <div className='w-[100px] h-[10px] bg-gray dark:bg-dark-9' />
                <div
                  className='h-[12px] bg-gray dark:bg-dark-9 mt-1.5'
                  style={{
                    width: `${Math.random() * 80 + 20}%`,
                  }}
                />
              </div>
            ))}
          </div>
          <div className='flex mt-[40px] space-x-[20px] divide-x divide-gray dark:divide-purple'>
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={`count-${i}`} className='flex items-center h-[20px]'>
                <div
                  className={cn(
                    'w-[100px] h-[14px] bg-gray dark:bg-dark-9 mobile:max-w-[50px]',
                    {
                      'ml-[20px]': i > 0,
                    }
                  )}
                  style={{
                    width: Math.random() * 60 + 60,
                  }}
                />
              </div>
            ))}
          </div>
          <div className='flex border-b border-gray dark:border-purple my-10 mobile:my-5' />
          <div className='flex flex-row items-center justify-start space-x-[40px]'>
            {Array.from({ length: 3 }).map((_, i) => (
              <div
                key={i}
                className='w-[80px] h-[14px] bg-gray dark:bg-dark-9'
              />
            ))}
          </div>
          <div className='desktop:hidden flex border-b border-gray dark:border-purple my-10' />
        </div>
      </div>
      <div className='w-full mobile:flex justify-center '>
        <hr className='bg-gray dark:bg-dark-9 h-[1px] my-8 border-0' />
        <div className='flex justify-center mobile:justify-start flex-wrap mobile:flex-nowrap overflow-x-scroll scrollbar-none scrollbar-none::-webkit-scrollbar space-x-[10px]'>
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={`tag-${i}`}
              className='bg-gray dark:bg-dark-9 px-[10px] py-[4px] rounded-[8px] h-[30px]'
              style={{
                width: Math.random() * 80 + 20,
              }}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
